













import { Component, Prop, Vue } from "vue-property-decorator";
import SuketIgdPage from "@/pages/PemeriksaanIgdPage/SuketIgdPage.vue";

@Component({
  components: {
    SuketIgdPage
  }
})
export default class ResumeSuketTabView extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop() readonly showingTab?: string;

  tab = "tab-soap";

  showTab(item) {
    this.tab = item;
  }
}
